module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/supplements@2x_5e529d.png";